const preScanHR = {
    "form": {
        "modal": {
            "preScanResults": {
                "header": "Rezultati Pre Scan-a",
                "body": {
                    "description": "Slijedeći rezultati su pronađeni nakon izvršavanja skeniranja za ovu izdanju, molimo provjerite ovo u detaljima:",
                    "table": {
                        "column": {
                            "trackName": "Naziv Pjesme",
                            "type": "Tip",
                            "title": "Naslov",
                            "artists": "Umjetnici",
                            "album": "Albuma",
                            "label": "Izdavačka Kuća",
                            "releaseDate": "Datum Izdanja",
                            "score": "Ocjena (%)"
                        },
                    },
                    "label": {
                        "flaggedTracks": "Označene Pjesme",
                        "music": "Glazba",
                        "cover": "Omot",
                        "signDeclaration": "Molimo potpišite deklaraciju kako biste nastavili.",
                        "cancelRelease": "Želim otkazati ovu izdanju.",
                        "approveRelease": {
                            "point1": "Želim odobriti ovu izdanju jer su rezultati prikazani 100% identični sa mojim izdanjem / prebacivanjem sa prethodnog distribuidera.",
                            "point2": "Podnosim sljedeću deklaraciju, pod kaznom perjury, da svi sadržaji koje pružam su vlasništvo moje tvrtke ili ja, ili da posjedujem potpuno i valjane pravne i licence potrebne za njihovo korištenje, distribuciju i predstavljanje.",
                            "point3": "Priznajem i prihvaćam da sam u potpunosti odgovoran za sve pravne posljedice koje mogu nastati iz predstavljanja takvih sadržaja, uključujući ali ne ograničujući se na pravne postupke, tvrdnje, troškove i naknade.",
                            "point4": "Dalje razumijem i prihvaćam da moji osobni podaci, uključujući informacije KYC i sve ostale relevantne podatke, mogu biti dijeljeni s autoriziranim partnerima, digitalnim servisnim pružateljima (DSPs), trećim stranama uključenim u obradu takvih sadržaja, kao i sudovima, regulativnim autoritetima i agencijama za primjenu zakona u slučaju bilo kakvog zahtjeva, sporova ili legalnih zahtjeva.",
                            "point5": "Razumijem i prihvaćam da Music Link rezervira pravo da neposredno prekine moj ugovor, bez bilo kakve kompenzacije ili dodatne obveze, ako se dokaže da sam ovo formulara neispravno koristio ili ako bilo koji dio moje deklaracije nije istinit, lažan ili neispravno predstavljen.",
                        },
                        "noFlaggedTracks": "Nema označenih pjesama detektiranih u pre-scan-u, možete nastaviti sa sljedećim koracima!"
                    },
                    "help_text": {
                    },
                },
                "button": {
                    "submit": "Pošalji",
                    "close": "Zatvori"
                }
            },
            "performScan": {
                "header": "Izvrši Pre-Scan",
                "body": "Molimo potvrdite da želite izvršiti pre-scan za ovu izdanju.",
                "button": {
                    "cancel": "Odustani",
                    "performScan": "Izvrši Scan"
                }
            }
        },
        "message": {
            "releaseDistributionCancelled": "Otkazali ste distribuciju izdanja, stoga je uklonjena.",
            "admin_pending": "Vaša deklaracija čeka na pregled administratora za daljnje djelovanje.",
            "admin_approved": "Vaš zahtjev za distribuciju vašeg izdanja odobren je od strane našeg administrativnog tima. Izdanje je uspješno verificirano. Cijenimo vašu marljivost u osiguravanju točnosti i usklađenosti. Izdanje će biti poslano u sve trgovine prema planu. Hvala vam na pažnji prema detaljima i pridržavanju naših standarda.",
            "admin_rejected": "Vaš zahtjev za distribuciju vašeg izdanja odbijen je. Nakon pažljivog pregleda, zahtjev ne ispunjava naše uvjete za odobrenje. Preporučujemo ponovno vrednovanje sadržaja i osiguravanje da su svi uvjeti i pravne implikacije ispunjeni. Hvala vam na razumijevanju i suradnji.",
            "scanInProgress": "Scan u toku, molimo pričekajte dok se scan završi.",
            "releaseMustBeReady": "Izdanje mora biti u statusu Ready za izvršavanje pre-scan-a.",
            "errorSubmittingDeclaration": "Došlo je do pogreške prilikom slanja deklaracije administratora pre-scan-a.",
        }
    }
};

export default preScanHR;